import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { CartItem, ItemType, ProductDetails } from '../../types/api-types';

type DrawerState = {
  active:
    | {
        id: 'ADD_TO_CART';
        data:
          | {
              type: 'item';
              itemDetails: ProductDetails;
              cartItem: CartItem;
              quantity: number;
              listPrice?: string;
              netPrice: string;
            }
          | {
              type: 'package';
              // items:
              //   | (DetailedPackageItem & { points: number; weight: number })[]
              //   | (DetailedNewPackageItem & {
              //       points: number;
              //       weight: number;
              //     })[];
              // itemHierarchy: PackageItemHierarchy<
              //   DetailedNewPackageItem | DetailedPackageItem
              // >;
              // packageName: string;
              packageId: string;
              packageType?: string;
              cartItems: CartItem[];
              // listPrice?: string;
              // netPrice: string;
            };
      }
    | {
        id: 'ADD_TO_LIST';
        data: { sku: string; imageUrl: string; itemType?: ItemType }[];
      }
    | null;
};

const initialState: DrawerState = {
  active: null,
};

const drawerSlice = createSlice({
  name: 'drawer',
  initialState,
  reducers: {
    openDrawer: (
      state,
      action: PayloadAction<Exclude<DrawerState['active'], null>>
    ) => {
      state.active = action.payload;
    },
    closeDrawer: state => {
      state.active = null;
    },
  },
});

export const { openDrawer, closeDrawer } = drawerSlice.actions;
export default drawerSlice;
